<template>
  <div id="app" class="container">
    <div class="row">
      <div class="column">
        <h3>WebRTC/SIP Dialler by Mark Willmoth</h3>
        <h6>Caelyn Dialler v0.0.1 (caelyn.markcw.io)</h6>
        <div v-if="!registered" class="login">
          <label>
            <span>End Point</span>
            <input type="text" v-model="wssEndPoint" />
          </label>

          <label>
            <span>Domain</span>
            <input  type="text" v-model="domain" />
          </label>

          <label>
            <span>User</span>
            <input  type="text" v-model="user" />
          </label>

          <label>
            <span>Password</span>
            <input type="password" v-model="password" />
          </label>

          <button type="button" @click="register">Login</button>
          <p class="error" v-if="registrationError">{{ registrationError }}</p>
        </div>

        <div v-if="registered && !connected" class="dialler">
          <label>
            <span>Extension</span>
            <input type="text" v-model="extension" />
          </label>
          <button type="button" v-if="video" @click="video=false">Disable Video</button>
          <button type="button" v-if="!video" @click="video=true">Enable Video</button>
          <button type="button" @click="connect">Connect</button>
          <button type="button" v-if="inviteSession" @click="acceptInvite">Accept Call</button>
        </div>

        <div v-if="connected && registered">
          <div>
            <button class="dtmf" @mousedown="sendDtmf(1)" @mouseup="endDtmf">
              1
            </button>
            <button class="dtmf" @mousedown="sendDtmf(2)" @mouseup="endDtmf">
              2
            </button>
            <button class="dtmf" @mousedown="sendDtmf(3)" @mouseup="endDtmf">
              3
            </button>
          </div>
          <div>
            <button class="dtmf" @mousedown="sendDtmf(4)" @mouseup="endDtmf">
              4
            </button>
            <button class="dtmf" @mousedown="sendDtmf(5)" @mouseup="endDtmf">
              5
            </button>
            <button class="dtmf" @mousedown="sendDtmf(6)" @mouseup="endDtmf">
              6
            </button>
          </div>
          <div>
            <button class="dtmf" @mousedown="sendDtmf(7)" @mouseup="endDtmf">
              7
            </button>
            <button class="dtmf" @mousedown="sendDtmf(8)" @mouseup="endDtmf">
              8
            </button>
            <button class="dtmf" @mousedown="sendDtmf(9)" @mouseup="endDtmf">
              9
            </button>
          </div>

          <div>
            <button class="dtmf" @mousedown="sendDtmf('*')" @mouseup="endDtmf">
              *
            </button>
            <button class="dtmf" @mousedown="sendDtmf(0)" @mouseup="endDtmf">
              0
            </button>
            <button class="dtmf" @mousedown="sendDtmf('#')" @mouseup="endDtmf">
              #
            </button>
          </div>

          <button type="button" @click="disconnect">Disconnect</button>
        </div>

        <div>
          <video
            v-show="showVideo && connected"
            controls
            playsinline
            autoplay
            ref="remoteVideo"
          ></video>
          <video v-show="false" ref="localVideo"></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const SIP = require("sip.js");
import DTMF from "@kimmel/dtmf";

export default {
  name: "App",
  components: {},
  props: {
    wssEndPoint: {
      type: String,
      default: "wss://bianca.markcw.io:7443"
    },
    domain: {
      type: String,
      default: "bianca.markcw.io"
    }
  },
  data() {
    return {
      user: null,
      password: null,
      session: null,
      ua: null,
      registrationError: null,
      registered: false,
      connected: false,
      extension: null,
      video: false,
      dtmf: null,
      inviteSession: null,
      showVideo: false
    };
  },
  mounted() {
    this.dtmf = new DTMF();
    window.addEventListener("mouseup", () => {
      this.dtmf.stop();
    });
  },
  methods: {
    acceptInvite(){
      if(this.inviteSession){
        this.inviteSession.accept()
      }
    },

    endDtmf(){
      this.dtmf.stop();
    },
   
    sendDtmf(key) {
      if (key !== null && key !== undefined) {
        this.dtmf.play(key);
        this.session.dtmf(key);
      }
    },
    disconnect() {
      this.session.bye();
      this.ua.unregister();
    },
    async connect() {
  
      this.session = this.ua.invite(this.extension, {
        sessionDescriptionHandlerOptions: {
          constraints: {
            audio: true,
            video: (this.video ? {
              cursor: 'always',
              displaySurface: ['application', 'browser', 'monitor', 'window' ]
             } : false)
        }
      }});
      this.session.on("trackAdded", async () => {
        // We need to check the peer connection to determine which track was added
        this.connected = true;

        const pc = this.session.sessionDescriptionHandler.peerConnection;


        this.showVideo = false;

        // Gets remote tracks
        const remoteStream = new MediaStream();
        pc.getReceivers().forEach(receiver => {
          this.showVideo = this.showVideo || receiver.track.kind === 'video';
          remoteStream.addTrack(receiver.track);
        });
        this.$refs.remoteVideo.srcObject = remoteStream;
        this.$refs.remoteVideo.play();


      
      });

      const disconnectMethod = () => {
        this.dtmf.stop();
        this.connected = false;
        this.$refs.remoteVideo.srcObject = null;
        this.showVideo = false;
      };

      this.session.on("failed", disconnectMethod);
      this.session.on("terminated", disconnectMethod);
      this.session.on("rejected", disconnectMethod);
      this.session.on("cancel", disconnectMethod);
    },
    register() {
      this.registrationError = null;
      this.ua = new SIP.UA({
        uri: `${this.user}@${this.domain}`,
        transportOptions: {
          wsServers: [this.wssEndPoint],
          traceSip: false
        },
        log:{
          level: "error"
        },
        authorizationUser: this.user,
        password: this.password,
        autostart: false
      });

      this.ua.on('invite', (session) => {
        this.inviteSession = session
      });

      this.ua.on("registrationFailed", () => {
        this.registrationError =
          "Failed to login, please check your credentials and try again";
      });

      this.ua.on("registered", () => {
        this.registered = true;
      });

      this.ua.on("unregistered", () => {
        this.registered = false;
      });

      this.ua.start();
    }
  }
};
</script>

<style lang="scss">
@import "../node_modules/milligram/src/milligram";

h3{
  margin-bottom: 0;
}



.dialler button{
  margin-right: 1em;
}
.dtmf {
  margin-right: 0.8em;
  margin-bottom: 0.8em;
}

audio,
video {
  margin-top: 1em;
  max-width: 640px;
}
</style>
